// Login page: brand panel on the left (logo, headline, what Saathi covers). The sign-in card stays on the right.
const POINTS = [
	["People and payroll", "Staff records, attendance, leave, salaries, PF, ESI, PT and TDS."],
	["Programmes", "Projects, indicators, beneficiaries and field data, including offline collection."],
	["Grants and finance", "Budgets by funder, purchase and payment approvals, and audit-ready accounts."],
	["Governance", "Policies, committees, compliance deadlines and confidential reporting."],
];

function brandPanel() {
	const content = document.querySelector(".page_content");
	if (!content || !document.querySelector("section.for-login") || content.querySelector(".sa-login-brand")) return;
	if (!document.querySelector('link[href*="Plus+Jakarta+Sans"]')) {
		const font = document.createElement("link");
		font.rel = "stylesheet";
		font.href = "https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@500;600;700;800&display=swap";
		document.head.append(font);
	}
	const dark = document.documentElement.dataset.theme === "dark";
	const aside = document.createElement("aside");
	aside.className = "sa-login-brand";
	aside.innerHTML = `
		<div class="sa-lb-inner">
			<img class="sa-lb-logo" src="/assets/saathi/images/${dark ? "saathi-logo-light" : "saathi-logo"}.svg?v=m3" alt="Saathi">
			<h1 class="sa-lb-title">HR, payroll, programmes and finance for NGOs.</h1>
			<p class="sa-lb-sub">Saathi keeps staff, grants, accounts and field data in one system. Each person sees only what their role allows.</p>
			<ul class="sa-lb-points">
				${POINTS.map(([t, d]) => `<li><div><b>${t}</b><span>${d}</span></div></li>`).join("")}
			</ul>
			<p class="sa-lb-trust">Role-based access · Two-factor sign-in for administrators</p>
		</div>`;
	content.prepend(aside);
	document.body.classList.add("sa-login-split");
}

document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", brandPanel) : brandPanel();
